import styled from "@emotion/styled"
import { FocusScope } from "@react-aria/focus"
import ModalContainer, { specTerms } from "components/modal/ModalContainer"
import { load } from "components/quickviews/utils"
import { useDictionary } from "contexts/Dictionary"
import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"
import { buttonReset } from "css/buttons"
import { headline30, legend100 } from "css/text"
import { AnimatePresence, motion } from "framer-motion"
import { Suspense, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { createPortal } from "react-dom"
import Image from "components/media/ImageCLD"
import getMediaQuery from "css/breakpoints"

const Button = styled.button`
  ${buttonReset}
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.3s;

  @media (hover: hover) {
    &:hover {
      color: rgb(var(--green));
    }
  }
`

const Box = styled(motion.div)`
  display: flex;
  flex-direction: column;
  min-height: 15vh;
  gap: 1rem;
  align-items: center;

  ${getMediaQuery("l")} {
    flex-direction: row-reverse;

    > img {
      aspect-ratio: 1;
      max-width: 200px;
    }
  }
`

const Title = styled.h2`
  ${headline30}
  margin-block-end: 1ex;
`

const Paragraph = styled.p`
  ${legend100}
`

// const contentVariants = {
//   hidden: { y: "-30%", x: "-50%" },
//   visible: { y: "-50%", x: "-50%" },
// }

async function getData({ slug, navigation, locale }) {
  const path = navigation.localize(`/glossary/${slug}.extra.json`, locale.current.codes.www)

  const data = await load(path).catch(err => console.verbose("••• err", err))

  return data[1][0]

  // try {
  //   const response = await fetch(path)
  //   if (!response.ok) {
  //     throw new Error(`Error fetching data: ${response.statusText}`)
  //   }
  //   const data = await response.json()
  //   return data
  // } catch (error) {
  //   console.error("Error fetching glossary data:", error)
  //   return null
  // }
}

const Dialog = forwardRef(function Dialog({ slug, onClose }, ref) {
  const navigation = useNavigation()
  const locale = useLocale()

  const [content, setContent] = useState(null)

  useImperativeHandle(ref, () => ({
    open: async () => {
      const data = await getData({ slug, navigation, locale })
      if (data) {
        setContent(data)
      }
      // animDialog(dialogScope.current, variants.visible, { duration: 0.2 })
      // animContent(contentScope.current, contentVariants.visible, { duration: 0.2 })
    },
    close: () => {
      // animDialog(dialogScope.current, variants.hidden, { duration: 0.2 }).then(() => dialogScope.current.close())
      // animContent(contentScope.current, contentVariants.hidden, { duration: 0.2 })
    },
  }))

  return (
    <FocusScope contain restoreFocus autoFocus>
      <ModalContainer onClose={onClose} className={specTerms} modalHeading='modal-heading'>
        {/* <Box initial={contentVariants.hidden}> */}
        <Box>
          <Suspense fallback={<p>Loading...</p>}>
            {content && (
              <>
                <div>
                  <Title id='modal-heading'>{content.heading}</Title>
                  <Paragraph dangerouslySetInnerHTML={{ __html: content.paragraph }} />
                </div>
                {Array.isArray(content.image_cld) && content.image_cld.length > 0 && <Image sizes='25vw' sources={content.image_cld} />}
              </>
            )}
          </Suspense>
        </Box>
      </ModalContainer>
    </FocusScope>
  )
})

export default function GlossaryBtn({ ariaDescribedby, id, children }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const rmodal = useRef()
  const dictionary = useDictionary()

  const bodyElement = process.browser && document.body

  const onClose = () => {
    rmodal.current?.close()
    setIsModalOpen(false)
  }

  const onOpen = () => {
    setIsModalOpen(true)
  }

  useEffect(() => {
    if (isModalOpen) {
      rmodal.current?.open()
    }
  }, [isModalOpen])

  return (
    <>
      {process.browser && createPortal(<AnimatePresence>{isModalOpen && <Dialog ref={rmodal} onClose={onClose} slug={id} />}</AnimatePresence>, bodyElement)}
      <span id={`more-info-${id}`} style={{ display: "none" }}>
        {dictionary.moreInformation()}
      </span>
      <Button type='button' className='info-btn' onClick={onOpen} aria-describedby={`more-info-${id}`}>
        {children}
      </Button>
    </>
  )
}
